import "./index.css";
// src/MoveProjectModal/MoveProjectModal.tsx
import Box from "@cloudscape-design/components/box";
import Button from "@cloudscape-design/components/button";
import Modal from "@cloudscape-design/components/modal";
import SpaceBetween from "@cloudscape-design/components/space-between";
import { useAppTranslation } from "@amzn/awsmp-max-translations";

// src/MoveProjectModal/MoveProjectModal.module.css
var MoveProjectModal_default = {
  iconContainer: "MoveProjectModal_iconContainer",
  textContent: "MoveProjectModal_textContent",
  lockBounce: "MoveProjectModal_lockBounce",
  lockShackle: "MoveProjectModal_lockShackle"
};

// src/MoveProjectModal/MoveProjectModal.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var MoveProjectModal = ({ visible, isAuthenticated = false, selectedCount, onCancel, onConfirm }) => {
  const { t } = useAppTranslation();
  const isSingle = selectedCount === 1;
  const header = isAuthenticated ? t(isSingle ? "moveProjectModalHeaderHomePageAuthedSingle" : "moveProjectModalHeaderHomePageAuthedMulti") : t("moveProjectModalHeaderHomePage");
  const confirmButtonText = isAuthenticated ? t(isSingle ? "moveProject" : "moveProjects") : t(isSingle ? "moveProjectModalConfirmHomePageSingle" : "moveProjectModalConfirmHomePageMulti");
  const title = t(isSingle ? "moveProjectModalTitleHomePageSingle" : "moveProjectModalTitleHomePageMulti");
  const description = isAuthenticated ? t(isSingle ? "moveProjectModalDescriptionHomePageAuthedSingle" : "moveProjectModalDescriptionHomePageAuthedMulti") : t(isSingle ? "moveProjectModalDescriptionHomePageSingle" : "moveProjectModalDescriptionHomePageMulti");
  return /* @__PURE__ */ jsx(
    Modal,
    {
      visible,
      onDismiss: onCancel,
      header,
      "data-testid": "move-project-modal",
      footer: /* @__PURE__ */ jsx(Box, { float: "right", children: /* @__PURE__ */ jsxs(SpaceBetween, { direction: "horizontal", size: "xs", children: [
        /* @__PURE__ */ jsx(Button, { variant: "link", onClick: onCancel, "data-testid": "move-project-modal-cancel", children: t("cancel") }),
        /* @__PURE__ */ jsx(Button, { variant: "primary", onClick: onConfirm, "data-testid": "move-project-modal-confirm-home-page", children: confirmButtonText })
      ] }) }),
      children: /* @__PURE__ */ jsxs(SpaceBetween, { size: "l", children: [
        /* @__PURE__ */ jsx("div", { className: MoveProjectModal_default.iconContainer, children: /* @__PURE__ */ jsxs("svg", { width: "96", height: "94", viewBox: "0 -8 112 109", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", children: [
          /* @__PURE__ */ jsx("g", { className: MoveProjectModal_default.lockShackle, children: /* @__PURE__ */ jsx(
            "path",
            {
              d: "M94.259 13.9791C94.259 7.58215 89.0733 2.39641 82.6763 2.39641C76.2794 2.39641 71.0937 7.58215 71.0937 13.9791V30.3546H74.8318V13.9791C74.8318 9.78799 78.2294 6.39044 82.4205 6.39044C86.6116 6.39044 90.0091 9.78799 90.0091 13.9791L89.8917 16.8771H94.1416L94.259 13.9791ZM96.538 18.0753C96.538 18.7371 96.0015 19.2735 95.3398 19.2735H88.6935C88.0317 19.2735 87.4953 18.7371 87.4953 18.0753L87.6127 13.9791C87.6127 11.1115 85.2881 8.78685 82.4205 8.78685C79.5529 8.78685 77.2283 11.1115 77.2283 13.9791V31.5528C77.2283 32.2145 76.6918 32.751 76.03 32.751H69.8955C69.2337 32.751 68.6973 32.2145 68.6973 31.5528V13.9791C68.6973 6.25865 74.9559 9.52249e-08 82.6763 0C90.3968 0 96.6554 6.25865 96.6554 13.9791L96.538 18.0753Z",
              fill: "#0F141A"
            }
          ) }),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M95.8566 37.018H2.39641V97.8536H95.8566V37.018ZM2.39641 34.6216H45.5007L32.7526 25.1623H2.39641V34.6216ZM98.253 99.0518C98.253 99.7135 97.7165 100.25 97.0548 100.25H1.19821C0.536456 100.25 0 99.7135 0 99.0518V23.9641C0 23.3024 0.536456 22.7659 1.19821 22.7659H33.1504C33.4076 22.7659 33.6584 22.8483 33.865 23.0015L49.5243 34.6216H97.0548C97.7165 34.6216 98.2529 35.1582 98.253 35.8198V99.0518Z",
              fill: "#0F141A"
            }
          ),
          /* @__PURE__ */ jsx("path", { d: "M50.7241 35.1474H97.0548V62.3068H50.7241V35.1474Z", fill: "#0F141A" }),
          /* @__PURE__ */ jsxs("g", { children: [
            /* @__PURE__ */ jsx("path", { d: "M55.5171 17.5737H110.347V57.45H55.5171V17.5737Z", fill: "#FBD332" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M110.348 16.3755C111.009 16.3758 111.546 16.9121 111.546 17.5737V57.45C111.546 58.1116 111.009 58.6479 110.348 58.6482H55.5171C54.8553 58.6482 54.3188 58.1117 54.3188 57.45V17.5737C54.3188 16.912 54.8553 16.3755 55.5171 16.3755H110.348ZM56.7153 56.2518H109.149V18.7719H56.7153V56.2518Z",
                fill: "#0F141A"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M82.6768 31.9521C85.3237 31.9522 87.4697 34.0982 87.4697 36.7451C87.4697 38.9782 85.9419 40.8535 83.875 41.3857V44.7012C83.8749 45.3628 83.3384 45.8994 82.6768 45.8994C82.0151 45.8994 81.4786 45.3628 81.4785 44.7012V41.3867C79.4113 40.8547 77.8838 38.9784 77.8838 36.7451C77.8838 34.0981 80.0298 31.9521 82.6768 31.9521Z",
                fill: "#0F141A"
              }
            )
          ] })
        ] }) }),
        /* @__PURE__ */ jsxs("div", { className: MoveProjectModal_default.textContent, children: [
          /* @__PURE__ */ jsx(Box, { variant: "h4", children: title }),
          /* @__PURE__ */ jsx(Box, { variant: "p", color: "text-body-secondary", children: description })
        ] })
      ] })
    }
  );
};
export {
  MoveProjectModal
};
//# sourceMappingURL=index.js.map
